var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroupLine = function SvgGroupLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 21.002a7.2 7.2 0 1 1 14.4 0h-1.8a5.4 5.4 0 1 0-10.8 0zm7.2-8.1a5.4 5.4 0 0 1-5.4-5.4c0-2.984 2.417-5.4 5.4-5.4s5.4 2.416 5.4 5.4a5.4 5.4 0 0 1-5.4 5.4m0-1.8c1.989 0 3.6-1.611 3.6-3.6s-1.611-3.6-3.6-3.6a3.6 3.6 0 0 0-3.6 3.6c0 1.989 1.611 3.6 3.6 3.6m7.456 3.332a7.2 7.2 0 0 1 4.244 6.568h-1.8a5.4 5.4 0 0 0-3.183-4.926l.738-1.642Zm-.62-10.16a4.95 4.95 0 0 1 1.77 7.916 4.95 4.95 0 0 1-3.206 1.592V11.97a3.15 3.15 0 0 0 .937-5.948l.5-1.749Z"
  })));
};
export default SvgGroupLine;